<script setup lang="ts">
import {
    SUPPORTED_PAGES_ENUM,
    type SUPPORTED_PAGES,
} from "~/common/breadCrumbs"
import ButtonDropdownStore from "./Store/ButtonDropdownStore.vue"

/**
 *
 *  Props and emits section
 *
 *
 */

defineProps<{
    menuItems: {
        route: string
        name: string
        page: SUPPORTED_PAGES
    }[]
}>()

/**
 *
 *  Ref, computed and hooks section
 *
 *
 */

const i18n = useI18n()

/**
 *
 *  Life cicle events
 *
 *
 */

/**
 *
 *  Functions section
 *
 *
 */
</script>

<template>
    <div class="tw-flex tw-flex tw-w-full tw-items-center tw-gap-5">
        <div class="tw-flex tw-flex-row tw-gap-2">
            <ButtonDropdownStore
                :menuItem="{
                    name: i18n.t('home.store'),
                    route: '/store',
                    page: SUPPORTED_PAGES_ENUM.Store,
                }"
            />
        </div>
        <NuxtLink
            to="/mayorista"
            class="tw-hidden md:tw-flex tw-items-center tw-gap-1 tw-text-md lg:tw-text-base tw-w-max tw-text-primary hover:tw-text-white hover:tw-bg-primary tw-font-bold tw-border tw-border-primary tw-rounded-full tw-px-4 tw-h-10 tw-transition-colors"
        >
            <q-icon name="storefront" size="16px" />
            Mayorista
        </NuxtLink>
        <template v-for="(menuItem, i) in menuItems" :key="i">
            <NuxtLink
                :to="menuItem.route"
                class="tw-hidden md:tw-flex tw-items-center tw-text-md lg:tw-text-base tw-w-max !tw-p-0 tw-text-customGray-500 hover:tw-text-primary tw-font-bold"
            >
                {{ menuItem.name }}</NuxtLink
            >
        </template>
    </div>
</template>
<style>
.custom-menu .q-menu {
    @apply !tw-shadow-none tw-border tw-border-customGray-100 !tw-top-[180px];
}

.custom-menu:hover .tw-dropdown-menu,
.custom-menu .tw-dropdown-menu:hover {
    display: block;
    z-index: 9;
}

.custom-menu svg {
    transform: rotateX(180deg);
}

.custom-menu .q-btn-dropdown__arrow {
    display: none;
}
</style>
